import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Repeat } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { TypeBadge } from "@/components/jobs/Badges";

export const useSeries = (enabled = true) => {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => (enabled ? api.get("/job-series").then((r) => setRows(r.data)).catch(() => {}) : Promise.resolve()), [enabled]);
  useEffect(() => { load(); }, [load]);
  const create = async (body) => {
    try { const { data } = await api.post("/job-series", body); toast.success(data.jobs_created ? `Repeat booking set up - ${data.jobs_created} job(s) added for the next 7 days` : "Repeat booking set up - jobs will appear on the board a week before each run"); load(); return true; }
    catch (e) { toast.error(errMsg(e)); return false; }
  };
  return { rows, load, create };
};

export const SeriesList = ({ rows, reload }) => {
  const [busy, setBusy] = useState("");
  if (!rows.length) return null;
  const stop = async (s) => {
    if (busy || !window.confirm(`Stop this repeat booking? Future jobs not yet assigned will be cancelled.`)) return;
    setBusy(s.id);
    try { const { data } = await api.post(`/job-series/${s.id}/stop`); toast.success(`Stopped - ${data.cancelled} upcoming job(s) cancelled${data.kept_assigned ? `, ${data.kept_assigned} already with a rider kept` : ""}`); reload(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  return (
    <section className="space-y-2 rounded-2xl border bg-card p-4" data-testid="series-list">
      <h2 className="flex items-center gap-2 font-bold"><Repeat className="h-4 w-4" /> Repeat bookings ({rows.length})</h2>
      {rows.map((s) => (
        <div key={s.id} className="flex flex-wrap items-center gap-2 rounded-xl border bg-background p-3 text-sm" data-testid={`series-${s.id}`}>
          <TypeBadge t={s.job_type} /><span className="font-semibold">{s.pickup_name} → {s.dropoff_name}</span>
          <span className="text-muted-foreground">{s.label}{s.end_date ? ` · until ${s.end_date}` : ""} · by {s.created_by}</span>
          <button onClick={() => stop(s)} className="ml-auto rounded-full border px-3 py-1 text-xs font-bold text-red-400" data-testid={`series-stop-${s.id}`}>Stop</button>
        </div>
      ))}
    </section>
  );
};
